export const logger = {
	enabled: false,
	enable(): void {
		this.enabled = true;
	},
	log(...args: any): void {
		if (this.enabled) {
			// eslint-disable-next-line no-console
			console.log('BM log: ', ...args);
		}
	},
	logCond(condition: boolean, ...args: any): void {
		if (this.enabled && condition && args.length > 1) {
			this.log(...args);
		}
	},
};
